// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getCreditHistoryProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetCreditHistoryProfessionalApi = createAsyncThunk(
  "hitGetCreditHistoryProfessionalApi",
  async () => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: {
         // search,
        },
      };
      const url = ApiBaseUrl + getCreditHistoryProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetCreditHistoryProfessionalSlice = createSlice({
  name: "getCreditHistoryProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetCreditHistoryClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetCreditHistoryProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetCreditHistoryProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetCreditHistoryProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetCreditHistoryClientData } = GetCreditHistoryProfessionalSlice.actions;
export default GetCreditHistoryProfessionalSlice.reducer;
